import { Transaction } from '@/reducers/admin/allTransactions.slice'
import { DateTime } from 'luxon'
import { DATE_FORMATS_LUXON } from '@/utils/dateHelpers'
import { useState } from 'react'
import { centsToDollars } from '@/utils/currencyHelpers'
import { CurrencyFormatLabel } from '@/components/CurrencyFormatLabel'
import { Button, Card, CardColors, Dialog, Text, Textarea, Label } from '@/ui'
import { TypographyStyles, TextColors } from '@/styles'

export const SampleTransactionNotesModal = ({
  isOpen,
  onClose,
  transaction,
  transactionNote,
  onNoteChange,
  onSave,
}: {
  isOpen: boolean
  onClose: () => void
  transaction: Transaction
  transactionNote: string | undefined
  onNoteChange: (value: string) => void
  onSave: () => Promise<void>
}) => {
  const [isSaving, setIsSaving] = useState(false)

  const handleSave = async () => {
    setIsSaving(true)
    try {
      await onSave()
    } catch (error) {
      console.error('Failed to save note:', error)
    } finally {
      setIsSaving(false)
    }
  }
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <Dialog.Content className="max-w-sm">
        <Dialog.Title>Add a note</Dialog.Title>
        <Card color={CardColors.LEVEL_1}>
          <div className="space-y-2">
            <Text variant={TypographyStyles.EYEBROW} color={TextColors.MUTED}>
              Transaction
            </Text>
            <Text>
              Date:{' '}
              {DateTime.fromISO(transaction.date).toFormat(
                DATE_FORMATS_LUXON.DISPLAY_SHORT
              )}
            </Text>
            <Text>Description: {transaction.description}</Text>
            <Text>
              Amount:{' '}
              <CurrencyFormatLabel
                value={centsToDollars(transaction.amountInCents)}
              />
            </Text>
          </div>
        </Card>

        <Label>Note</Label>
        <Textarea
          rows={2}
          value={transactionNote || ''}
          onChange={(e) => onNoteChange(e.target.value)}
        />
        <Dialog.Footer>
          <Dialog.Close asChild>
            <Button variant="secondary" onClick={onClose}>
              Cancel
            </Button>
          </Dialog.Close>
          <Button onClick={handleSave} disabled={isSaving} loading={isSaving}>
            Save Note
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
